import { css } from '@emotion/react';
import usingPhoneBackground from '@assets/images/using_phone_background.png';
import { Gray, White } from '@constants/color';

export const container = css({
  width: 1920,
  height: 1080,
  display: 'flex',
  color: White.White10,
  backgroundImage: `url(${usingPhoneBackground})`
});

export const rightSideContainer = css({
  width: 752,
  backgroundColor: Gray.Gray90,
  padding: '160px 64px 64px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});
